import { render, staticRenderFns } from "./AdquisicionPreca.vue?vue&type=template&id=49f36cbe&scoped=true&lang=html&"
import script from "./AdquisicionPreca.vue?vue&type=script&lang=js&"
export * from "./AdquisicionPreca.vue?vue&type=script&lang=js&"
import style0 from "./AdquisicionPreca.vue?vue&type=style&index=0&id=49f36cbe&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f36cbe",
  null
  
)

export default component.exports